<template>
    <section class="fibu-sum-list">
        <Table
            :fields="fields"
            :items="items"
            small
            :isBusy="busy"
            sortBy="category_name"
        >
            <template v-slot:category_name="{ row: row }">
                <template v-if="!row.item.category">
                    {{ row.value }}
                </template>
                <template v-else>{{
                    findCategory(row.item.category)
                }}</template>
            </template>

            <template v-slot:income="{ row: row }">
                <div v-html="currencyColored(row.value)"></div>
            </template>

            <template v-slot:outcome="{ row: row }">
                <div v-html="currencyColored(row.value)"></div>
            </template>

            <template v-slot:total="{ row: row }">
                <div v-html="currencyColored(row.value)"></div>
            </template>

            <template v-slot:custom-foot>
                <b-tr>
                    <b-td>Sonstige</b-td>
                    <b-td class="text-right">
                        <div v-html="currencyColored(other_sums.income)"></div>
                    </b-td>
                    <b-td class="text-right">
                        <div v-html="currencyColored(other_sums.outcome)"></div>
                    </b-td>
                    <b-td class="text-right">
                        <div v-html="currencyColored(other_sums.total)"></div>
                    </b-td>
                </b-tr><b-tr>
                    <b-th>Summen</b-th>
                    <b-th class="text-right">{{
                        currency(total_sums.income)
                    }}</b-th>
                    <b-th class="text-right">{{
                        currency(total_sums.outcome)
                    }}</b-th>
                    <b-th class="text-right">{{
                        currency(total_sums.total)
                    }}</b-th>
                </b-tr>
            </template>
        </Table>
    </section>
</template>

<script>
import Rights from "@/mixins/Rights/Rights";
import Currency from "@/mixins/Currency/Currency";
import { ApiFactory } from "@/api/ApiFactory.js";
import Table from "@/components/Table/Table";

const FiBuBuchungApi = ApiFactory.get("fibuBuchung");
const FiBuCategoryApi = ApiFactory.get("fibuCategory");

export default {
    name: "FiBuSumList",
    mixins: [Rights, Currency],
    props: {
        group_id: {
            type: [Number, String],
            default: null
        },
        filter: {
            type: Object,
            default: null
        }
    },
    components: {
        Table
    },
    data() {
        return {
            busy: false,
            category_sums: [],
            other_sums: {},
            total_sums: {},
            category: {
                busy: false,
                items: []
            },
            showEmpty: false,
            fields: [
                {
                    key: "category_name",
                    label: "Kategorie",
                    sortable: true
                },
                {
                    key: "income",
                    label: "Einnahmen",
                    sortable: true,
                    class: "text-right"
                },
                {
                    key: "outcome",
                    label: "Ausgaben",
                    sortable: true,
                    class: "text-right"
                },
                {
                    key: "total",
                    label: "Summe",
                    sortable: true,
                    class: "text-right"
                }
            ]
        };
    },
    created() {
        this.fetchCategory();
    },
    watch: {
        group_id: {
            handler() {
                this.fetch();
            },
            immediate: true
        },
        filter: {
            handler() {
                this.fetch();
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        items() {
            var sums = this.category_sums.map(item => {
                var el = {
                    category: item.category,
                    category_name: this.findCategory(item.category)
                };
                Object.assign(el, item.sums);
                return el;
            });
            return sums;
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            if (this.group_id !== null && this.filter) {
                const response = await FiBuBuchungApi.getGroupedSums(
                    this.group_id,
                    {
                        filter: this.filter
                    }
                );
                if (response.ok) {
                    if (!this.showEmpty) {
                        this.category_sums = response.json.category_sums.filter(
                            item =>
                                item.sums.income != 0 || item.sums.outcome != 0
                        );
                    } else {
                        this.category_sums = response.json.category_sums;
                    }
                    this.other_sums = response.json.other_sums.sums;
                    this.total_sums = response.json.total_sums.sums;
                    this.registerRights(response);
                }
            }
            this.busy = false;
        },
        async fetchCategory() {
            this.category.busy = true;
            const response = await FiBuCategoryApi.get();
            if (response.ok) {
                this.category.items = response.json.collection;
            }
            this.category.busy = false;
        },
        findCategory(categoryId) {
            const result = this.category.items.find(el => el.id === categoryId);
            if (result) {
                return `${result.description}`;
            } else {
                return "-";
            }
        }
    }
};
</script>
